import { gql } from "@apollo/client";

export const GET_ARTICLES = gql`
  query GET_ARTICLES($type: AnyArticleFilterInput, $sort: AnyArticleSortInput, $first: Int, $last: Int, $before: String, $after: String) {
    search(where: $type sort: $sort first: $first last: $last before: $before after: $after) {
      totalCount
      edges {
        cursor
        node {
          ... on RentalAccommodationArticle {
            id
            slug
            recommended
            title { value }
            lowestPrice { onDemand type value }
            discounts { fixedValue logic percentageValue period type }
            features { parkings maxGuests withWIFI }
            address { city }
            images {
              main
              title { value }
              alternativeText { value }
              assets { breakpoint height url width }
            }
          }
          ... on SeasonalAccommodationArticle {
            id
            slug
            recommended
            title { value }
            seasonalPrice: price { isMonthly onDemand period value }
            features { parkings maxGuests withWIFI }
            address { city }
            images {
              main
              title { value }
              alternativeText { value }
              assets { breakpoint height url width }
            }
          },
          ... on AnnualAccommodationArticle {
            id
            slug
            recommended
            title { value }
            annualPrice: price { availableAt onDemand value }
            address { city }
            features { parkings livingSpace rooms }
            address { city }
            images {
              main
              title { value }
              alternativeText { value }
              assets { breakpoint height url width }
            }
          },
          ... on SaleAccommodationArticle {
            id
            slug
            recommended
            novelty
            promoted
            title { value }
            salePrice: price { onDemand value }
            features { parkings livingSpace rooms }
            address { city }
            images {
              main
              title { value }
              alternativeText { value }
              assets { breakpoint height url width }
            }
          }
        }
        accommodationBookingSuggestion {
          bookable
          period
          priceOnDemand
          price { amount }
        }
      }
      accommodationMapMarkers { coordinates id slug }
      paginationInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        lastPageCursor
        nextPageCursor
        pageCount
        pageSize
        previousPageCursor
        linkPageCursors { cursor page }
      }
    }
  }
`;
